import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidator } from "../common/services/formValidator.service";
import { CommonConstants } from "../common/utilities/commonConstants";
import { EpbitlyService } from "../epbitly/epbitly.service";
import { RouteContextProvider } from "../common/services/routeContextProvider.service";
import { CookieHandlerService } from "../common/services/cookieHandler.service";
import { environment } from "src/environments/environment";
import { HttpParams } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { RouteHandlerService } from "../bank-selection/bank-selection/route-handler.service";
import { allctaInteraction, initiPageInfo } from "../common/services/adobe-service";

@Component({
  selector: "app-user-details",
  templateUrl: "./user-details.component.html",
  styleUrls: ["./user-details.component.scss"],
})
export class UserDetailsComponent implements OnInit {
  userDetailsForm!: FormGroup;
  isvalidform: string;
  showUserDetailsMobScreen = true;
  productCode: string;
  appUtmSource: string;
  appUtmMedium: string;
  appUtmCampaign: string;
  appUtmContent: string;
  appUtmTerm: string;
  authCode: string;
  utmObj:any
  showlinkExpireMsg: boolean;
  pan: any;
  mobileNumber: any;
  ntcSettings: {
    data: { mobileNumber: any,dateOfBirth?:any};
    //returnURL: string;
    //occupationIdentifier: string;
  };
  source: string;
  sourceChanel: string;
  partnerType: string;
  productid: string;
  paramsObj: any;
  eligibleAggregator: string;
  aaTransactionStatus: any;

  constructor(
    private formBuilder: FormBuilder,
    public formValidator: FormValidator,
    private _epbitlyService: EpbitlyService,
    private _routeContextProvider: RouteContextProvider,
    private _cookieHandler: CookieHandlerService,
    private _route: Router,
    private _activatedRoute:ActivatedRoute,
    private _routeHandlerService: RouteHandlerService,

  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.getParamsObj();
    this.checkQueryParams();
    this.addAdobeScript();
    initiPageInfo('standaloneaa','get your bank consent', 'open arch:web', 'CAMPAIGN', '', '','', '', '','WEB','', '', '','', '');// account aggregator call on page load
  }
  getParamsObj(){
  this._activatedRoute.queryParams.subscribe(params => {
   this.paramsObj = params;
});
}
  public buildForm() {
    this.userDetailsForm = this.formBuilder.group({
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^\\d{10}$"),
          this.formValidator.validateMobNumber,
        ]),
      ],
    });
  }
  public validateData(): void {
    console.log("formvalue");
  }

  public isdCodeStyle(event: any) {
    this.showlinkExpireMsg=false;
    let isMobValue = null;
    let element: any;
    isMobValue = this.userDetailsForm.controls?.["mobile"].value;
    element = document.getElementById("isdCode");

    if (event?.type === "click" || event?.type === "focus") {
      element.style.setProperty("display", "flex", "important");
      element.style.setProperty("top", "1px", "important");
      element.style.setProperty("padding-top", "15px", "important");
      element?.style?.setProperty("color", "#111", "important");
      element?.style?.setProperty("font-family", "Lato-bold", "important");
    } else {
      let mobile = this.userDetailsForm.controls?.["mobile"].value;
      if (isMobValue || mobile.length > 0) {
        element.style.setProperty("display", "flex", "important");
        element.style.removeProperty("top");
        element.style.removeProperty("padding-top");
      } else {
        element.style.removeProperty("display");
      }
    }
  }

  private checkQueryParams(): void {
    this.productCode = "FD";
   // this.sourceChanel = sessionStorage.getItem(CommonConstants.setAaStorageKeySingleLink.sourceChannel)
    //this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.productCode);
    if (sessionStorage.getItem(CommonConstants.CookieKeys.redirectionUrlForJourney)) {
      this.source = 'standaloneaa'
    }
    else{
      this.source = 'ep'
    }
     //CommonConstants.QueryParamsKeys.source;
    //  this.partnerType = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.partnerType);
    this.appUtmSource = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmSource);
    this.appUtmMedium = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmMedium);
    this.appUtmCampaign = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmCampaign);
    this.appUtmContent = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmContent);
    this.appUtmTerm = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmTerm);
    this.authCode = this._routeContextProvider.GetQueryParams(
      CommonConstants.QueryParamsKeys.authCode
    );
    this.utmObj = {
      utm_source: this.appUtmSource,
      utm_medium: this.appUtmMedium,
      utm_campaign: this.appUtmCampaign,
      utm_content: this.appUtmContent,
      utm_term: this.appUtmTerm
    };
    this.updateUtmObj();
   // this.staticLinkFlow(this.productCode);
  }
  updateUtmObj(){
    for (let [key, value] of Object.entries(this.utmObj)) {
      if (value === '""' || value === '“”') {
        this.utmObj[key] = ""
      }
  }
  }
  staticLinkFlow() {
    const requestPayload = {
      mobileNumber: this.userDetailsForm.controls.mobile.value,
    };
    this._cookieHandler.deleteCookie(CommonConstants.CookieKeysAA.authtoken);
    this._epbitlyService.staticLinkFlow(this.productCode, requestPayload).subscribe({
      next: (res) => {
        if (res.status === 200) {
          allctaInteraction('standaloneaa', 'SUBMIT', 'CAMPAIGN','WEB',res?.body?.mobileNumber,'','','','');
          this.pan = res?.body?.pan;
          this.mobileNumber = res?.body?.mobileNumber;
          this.ntcSettings = {
            data: {
              mobileNumber: this.mobileNumber
            }
          };
          if (res?.body?.pan) {
            this.ntcSettings.data["pan"] = res?.body?.pan;
          }
          this.ntcSettings.data["dateOfBirth"] = ((res?.body?.dateOfBirth) ? (res?.body?.dateOfBirth) : null) ;
          this.eligibleAggregator= res?.body?.eligibleAggregator;
          this.aaTransactionStatus = res?.body?.aaTransactionStatus;
          this.selectedEligibleAgggreator(this.eligibleAggregator,this.aaTransactionStatus);
  }
      },
      error: () => {
        console.log('error')
      }
    })
  };

  selectedEligibleAgggreator(aggregator:string,aaTransactionStatus:any){
    switch (aggregator.toLocaleLowerCase()) {
      case CommonConstants.AAPartners.finvu:
        switch ((aaTransactionStatus || '').toLowerCase()) {
          case CommonConstants.aastatus.inProcess.toLocaleLowerCase():
            break;
        
          default:
            this.clearFipData();
            sessionStorage.setItem(CommonConstants.QueryParamsKeys.dob,this.ntcSettings?.data?.dateOfBirth);
            sessionStorage.setItem(CommonConstants.setAaStorageKeySingleLink.mobileNumber,this.ntcSettings?.data?.mobileNumber);
            sessionStorage.setItem(CommonConstants.QueryParamsKeys.partnerType, CommonConstants.AAPartners.finvu);
            sessionStorage.setItem(CommonConstants.setAaStorageKeySingleLink.occupationIdentifier,'CAMPAIGN');
            sessionStorage.setItem(CommonConstants.setAaStorageKeySingleLink.source,this.source);
            sessionStorage.setItem(CommonConstants.setAaStorageKeySingleLink.sourceChannel,'WEB');
            this.navigateToAA(); 
            break;
        }
        break;
    
      case CommonConstants.AAPartners.pirimid:

        switch ((aaTransactionStatus || '').toLowerCase()) {
          case CommonConstants.primidStatus.inProcess.toLocaleLowerCase():
            this._route.navigate([CommonConstants.Routes.inprogessPage]);
            break;
          
          default:
            this.clearFipData();
            sessionStorage.setItem(CommonConstants.setAaStorageKeySingleLink.mobileNumber,this.ntcSettings?.data?.mobileNumber);
            sessionStorage.setItem(CommonConstants.QueryParamsKeys.partnerType, CommonConstants.AAPartners.pirimid);
            sessionStorage.setItem('occupationIdentifier','CAMPAIGN');
            // sessionStorage.setItem('redirectionUrl','');
            this.navigateToAA();  
            break;
        } 

        break;

      default:
        break;
    }
  }

  clearFipData(){
    const bank = sessionStorage.getItem(CommonConstants.finvuStorageKeys.fipDetails);
    const consent = sessionStorage.getItem(CommonConstants.finvuStorageKeys.ConsentApproved);
    bank && sessionStorage.removeItem(CommonConstants.finvuStorageKeys.fipDetails);
    consent && sessionStorage.removeItem( CommonConstants.finvuStorageKeys.ConsentApproved);
  }

  navigateToAA() {
    //let queryParams:any = new HttpParams({fromObject: this.utmObj});
    let newObj = Object.entries(this.paramsObj).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {});
    this._routeHandlerService.NavigateToViewWithQueryParams([CommonConstants.Routes.StandAloneBankSelection],newObj)
    // const partnerUrl = environment.serviceBaseUrls.DOMAIN02 + partnerBaseUrl + '?' + queryParams;
    // const partnerUrl = 'http://localhost:4200' + '?' + queryParams;
    // window.open(partnerUrl, "_self");
  }

  private addAdobeScript() {
    // attach adobe script to body tag
    const script = document.createElement('script');
    script.setAttribute('src', environment.adobefinvuScript);
    script.setAttribute('type', 'text/javascript');
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
}
